import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ConfigurationService } from "@services/configuration.service";
import { AppService } from "../app.service";
import {
  TokenInterceptor,
  TOKEN_INTERCEPTOR_BLOCK_LIST,
} from "./interceptors/token.interceptor";
import {
  TOKEN_INTERCEPTOR_MULTIBROKER_LIST, TokenMultiBrokerInterceptor,
} from "./interceptors/token-negotiation.interceptor";
import { USER_IDENTIFIER_INTERCEPTOR, UserIdentifierInterceptor } from "./interceptors/user-identifier.interceptor";


export const BlockListToken: RegExp[] = [
  /(((https?):\/\/|www\.)viacep.com.br\/ws\/)/,
  /\/auth\/users\/login/,
  /\/auth\/revoke_token/,
  /\/env/,
  /\/refresh_token/,
  /\/api.pagar.me/,
  /\/services\/AuthFast\/LoginO/
];

export const MultiBrokerList: RegExp[] = [
  /\/workspace/,
  /\/charts/,
  /\/facade\/services/,
  /\/services\/AuthFast\/LoginO/
];

export const UserIdentifierList: RegExp[] = [];

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
  ],
  providers: [
    AppService,
    ConfigurationService,
    // { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: TokenMultiBrokerInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: UserIdentifierInterceptor, multi: true },
    { provide: TOKEN_INTERCEPTOR_BLOCK_LIST, useValue: BlockListToken },
    { provide: TOKEN_INTERCEPTOR_MULTIBROKER_LIST, useValue: MultiBrokerList },
    { provide: USER_IDENTIFIER_INTERCEPTOR, useValue: UserIdentifierList },
  ]
})
export class CoreModule { }
